import { getBrowserLanguage } from 'documents-lib/js/utils/getBrowserLanguage';
import isChirpInURL from 'documents-lib/js/utils/isChirpInURL';
export const needsToLoadLocale = consentObject => {
  const legalConsentEnabled = isChirpInURL() ? consentObject.documentLegalConsentEnabled : consentObject.deckLegalConsentEnabled;
  return !getBrowserLanguage() && legalConsentEnabled;
};